import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import cn from 'classnames';

export type FormCheck = TParentComponentProps & {
  disabled?: boolean;
};

export const FormCheck: FunctionComponent<TParentComponentProps> = ({
  disabled,
  className,
  ...props
}) => {
  const componentClassName = cn({
    'form-type-check--disabled': !!disabled,
    [className]: !!className,
  });

  return <ParentComponent className={componentClassName} {...props} />;
};

FormCheck.defaultProps = {
  defaultClassName: 'form-type-check',
  as: 'div',
};

export default FormCheck;
